import { render } from "./AndroidCardEn.vue?vue&type=template&id=cf73d166&scoped=true"
import script from "./AndroidCardEn.vue?vue&type=script&lang=js"
export * from "./AndroidCardEn.vue?vue&type=script&lang=js"

import "./AndroidCardEn.vue?vue&type=style&index=0&id=cf73d166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf73d166"]])

export default __exports__